module.exports = __webpack_public_path__ + "img/四通道超高频读写器.f7cb71f0.jpg";